import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationRouteNames } from '@core/presentation';
import { NavigationService } from '@core/application';

@Component({
  selector: 'app-signup-selection',
  templateUrl: './signup-selection.page.html',
  styleUrls: ['./signup-selection.page.scss'],
})
export class SignupSelectionPage {
  constructor(private router: Router, private navigationService: NavigationService) {}

  onAdminClick() {
    this.router.navigate(['/authentication', AuthenticationRouteNames.adminSignUp]);
  }

  onEmployeeClick() {
    this.router.navigate(['/authentication', AuthenticationRouteNames.joinOrganization]);
  }

  goBack() {
    this.navigationService.back();
  }
}
